import closeMegaMenu from 'redux/modules/mega-menu/actions/close-mega-menu';
import resetMegaMenu from 'redux/modules/mega-menu/actions/reset-mega-menu';

export default () => dispatch => {
  // close the mega-menu
  dispatch(closeMegaMenu());
  // reset the mega-menu
  dispatch(resetMegaMenu());
};
